<!--
  Everything the sidebar mode adds to the page, in one component that the
  Layout mounts only when the `sidebar-nav` flag is on. It owns the unread
  messages channel, so with the flag off nothing here subscribes or runs.

  It renders where the top bar was. The sidebar and the tab bar are fixed, so
  only the phone top bar takes space in the page. The More sheet and the
  coming-soon window teleport out.
-->
<template>
  <AppSidebar
    :counts="counts"
    :mark-messages-as-read="markMessagesAsRead"
    :mark-notifications-as-seen="markNotificationsAsSeen"
  />
  <MobileTabBar
    :counts="counts"
    :mark-messages-as-read="markMessagesAsRead"
    :mark-notifications-as-seen="markNotificationsAsSeen"
  />
  <MobileMoreSheet
    :counts="counts"
    :mark-messages-as-read="markMessagesAsRead"
    :mark-notifications-as-seen="markNotificationsAsSeen"
  />
  <ComingSoonModal />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import AppSidebar from './AppSidebar.vue'
import MobileTabBar from './MobileTabBar.vue'
import MobileMoreSheet from './MobileMoreSheet.vue'
import ComingSoonModal from './ComingSoonModal.vue'
import { useSidebarCounts } from './useSidebarCounts'
import { useSidebarState } from './useSidebarState'

const { counts, markMessagesAsRead, markNotificationsAsSeen } =
  useSidebarCounts()
const { loadCollapsed } = useSidebarState()

// The fold and the Labs group live in this browser only, so they load
// after mount. The server renders the open sidebar, with the current group
// open.
onMounted(() => {
  loadCollapsed()
})
</script>
